import React, { useState, useEffect, useRef } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import Loading from "../loading";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { BASE_URL } from "../../utils/config";
import { ProgressBar } from 'react-loader-spinner'
import Tooltip from '@mui/material/Tooltip';

import { Link,useNavigate } from 'react-router-dom';

const PerformanceTable = (props) => {
  const navigate = useNavigate();
  const Record = props.Record
  console.log("Reocrd",Record)
  const Record1 = props.Record1
  console.log("Recordq1",Record1)
  const selectedTab = props.selectedTab
  const UpdateTabData = props.UpdateTabData
  const RemoveItem = props.RemoveItem
  const [marginUpdateModal, setmarginUpdateModal] = useState(false)
  const [LotSizeUpdateModal, setLotSizeUpdateModal] = useState(false);
  const [AlertModal, setAlertModal] = useState(false);
  const [AlertModalMargin, setAlertModalMargin] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [ErrorShow, setErrorShow] = useState(false);
  const [newmargin, setnewmargin] = useState("")
  const [NewLotSize, setNewLotSize] = useState("")
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [SelectedRow, setSelectedRow] = useState({});
  const [AlertMessage, setAlertMessage] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");


  let columns = [];
  let columns1 = [];

  if (selectedTab === "Future") {
    columns = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'LotSize', label: 'Lot size', minWidth: 80 },
      { id: 'Entry', label: 'Entry @', minWidth: 90 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 80 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'Margin', label: 'Margin', minWidth: 110 },
      { id: 'TotalMargin', label: 'Total Margin', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];

  } else if (selectedTab === "Option") {
    columns = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'LotSize', label: 'Lot size', minWidth: 80 },
      { id: 'Entry', label: 'Entry @', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 75 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];
    columns1 = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'LotSize', label: 'Lot size', minWidth: 80 },
      { id: 'Entry', label: 'Entry @', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 75 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];

  } else if (selectedTab === "IndexOption") {
    columns = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'LotSize', label: 'Lot size', minWidth: 80 },
      { id: 'Entry', label: 'Entry @', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 80 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },

    ];

  } else if (selectedTab === "Delivery") {
    columns = [
      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'Entry', label: 'Entry Price', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit Price', minWidth: 80 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];

  } else if (selectedTab === "Hni") {
    columns = [
      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'Entry', label: 'Entry Price', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit Price', minWidth: 80 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];

  } else if (selectedTab === "MCX") {
    columns = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Commodity', minWidth: 75 },
      { id: 'lot', label: 'Lot', minWidth: 80 },
      { id: 'lot_size', label: 'Lot size', minWidth: 80 },
      { id: 'Entry', label: 'Entry @', minWidth: 90 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 80 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'Margin', label: 'Margin', minWidth: 110 },
      { id: 'TotalMargin', label: 'Total Margin', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];

  }else if(selectedTab === "IntraDay"){
    columns = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'LotSize', label: 'Lot size', minWidth: 80 },
      { id: 'Entry', label: 'Entry @', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 75 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];

    columns1 = [

      { id: "S.No", label: "S.No", minWidth: 40 },
      { id: 'Action', label: 'Action', minWidth: 60 },
      { id: 'Scrip', label: 'Scrip', minWidth: 75 },
      { id: 'Type', label: 'Type', minWidth: 90 },
      { id: 'Entry', label: 'Entry @', minWidth: 110 },
      { id: 'EntryDate', label: 'Entry Date', minWidth: 110 },
      { id: 'ExitPrice', label: 'Exit @', minWidth: 75 },
      { id: 'ExitDate', label: 'Exit Date', minWidth: 110 },
      { id: 'SL', label: 'SL', minWidth: 70 },
      { id: 'P/L', label: 'P/L', minWidth: 110 },
    ];
  }



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex)
    let endindex = Math.min(startindex + rowsPerPage, Record.length)
    console.log("endindex", endindex)
    setStartIndex(startindex);
    setEndIndex(endindex)

  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };

  const updateMargin = (row) => {
    console.log("row", row)
    setSelectedRow(row);
    // setmarginUpdateModal(true);
    setAlertModalMargin(true);
    setnewmargin(row.Margin);
  }

  const updateLotsize = (row) => {
    console.log("row", row)
    setSelectedRow(row);
    // setLotSizeUpdateModal(true);
    setAlertModal(true);
    setNewLotSize(row.lot);
  }
  
  const handleshowEditmodal =()=>{
    setAlertModal(false);
     setLotSizeUpdateModal(true);
  }

  const handleshowEditMarginmodal = ()=>{
    setAlertModalMargin(false);
    setmarginUpdateModal(true);
  }

  const HandleMarginUpdate = async () => {
    console.log("new margin", newmargin);
    if (newmargin.trim() === '') {
      setAlertMessage('Please enter a valid Margin');
      setErrorShow(true);
      setTimeout(() => {
        setErrorShow(false);
      }, 2000);
      return
    }
    setLoading(true)
    let loginuser = JSON.parse(localStorage.getItem("loginData"));

    await fetch(`${BASE_URL}/UpdateMargin/${SelectedRow.id}/${newmargin}/${selectedTab}`, {
      method: "PUT",
      headers: {
      
         'Authorization': `Bearer ${loginuser.token}`
    },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success === true) {
          setAlertMessage(res.message)
          setLoading(false)
          setmarginUpdateModal(false);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
          }, 3000);
          UpdateTabData();

          // alert(res.message)
        } else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
         else {
          setAlertMessage(res.message);
          UpdateTabData();
          setLoading(false);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
          }, 3000);
          // alert(res.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        setAlertMessage(error);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
        console.error("Error fetching data:", error);
      });
  }

  const HandleLotSizeUpdate = async () => {
    console.log("NewLotSize", NewLotSize);
    if (NewLotSize.trim() === '') {
      setAlertMessage('Please enter a valid Lot size');
      setErrorShow(true);
      setTimeout(() => {
        setErrorShow(false);
      }, 2000);
      return
    }
    setLoading(true)
    let loginuser = JSON.parse(localStorage.getItem("loginData"));
    await fetch(`${BASE_URL}/UpdateLotSize/${SelectedRow.id}/${NewLotSize}`, {
      method: "PUT",
      headers: {
        
         'Authorization': `Bearer ${loginuser.token}`
    },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success === true) {
          setAlertMessage(res.message)
          setLoading(false)
          setLotSizeUpdateModal(false);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
          }, 3000);
          UpdateTabData();

          // alert(res.message)
        } else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }else {
          setAlertMessage(res.message);
          UpdateTabData();
          setLoading(false);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
          }, 3000);
          // alert(res.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        setAlertMessage(error);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
        console.error("Error fetching data:", error);
      });
  }

  const handlemarginchange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setnewmargin(value)
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }

  const handleLostSizechange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
    // if (value.trim() !=="") {
      setNewLotSize(value);
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }

  const handleRemoveformArray =(row,value)=>{

    console.log("remove item to array",row,value)
    RemoveItem(row,selectedTab,value)
  } 




  return (
    <div style={{ marginTop: '5px' }} className='screenerTab'>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
            <TableHead >
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      textAlign: 'center',
                      minWidth: column.minWidth,
                      backgroundColor: '#DAE7FF',
                      padding: 0,
                      color: '#000 !important',
                      fontWeight: '500',
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: '13px',
                      padding: '10px 2px'
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Record
                .slice(startIndex, endIndex)
                .map((row, index) => {

                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              position: 'sticky',
                              backgroundColor: '#fff',
                              fontWeight: '500',
                              fontFamily: "'Poppins', sans-serif",
                              fontSize: '13px',
                              padding: '5px 2px'
                            }}
                            class="table-cell-screenerTab"
                            key={column.id}
                            align={column.align}
                          >
                            {column.id === "S.No"
                              ? <div>{index + 1}  <span onClick={()=>{ handleRemoveformArray(row,0) }}><CancelIcon  sx={{ width: 20, height: 20 ,color:'#23499E'}} /></span>  </div>
                              : column.id === 'Margin'
                                ? <div style={{ textAlign: 'right' }}>
                                  {value}
                                  <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => updateMargin(row)}>
                                    <Tooltip title={value === '' ? "Enter margin" : "Edit margin"} placement="right">
                                      {value === '' ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                    </Tooltip>
                                  </span>
                                </div> : column.id === 'lot'
                                  ? <div style={{ textAlign: 'right' }}>
                                    {value}
                                    <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => updateLotsize(row)}>
                                      <Tooltip title={value === '' ? "Enter Lot " : "Edit Lot "} placement="right">
                                        {value === '' ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                      </Tooltip>
                                    </span>
                                  </div> : value
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={Record.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

       {selectedTab === "IntraDay" ?
       <Paper sx={{ width: '100%', overflow: 'hidden' }}>
       <TableContainer sx={{ maxHeight: 500 }}>
         <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
           <TableHead >
             <TableRow>
               {columns1.map((column, index) => (
                 <TableCell
                   key={column.id}
                   align={column.align}
                   style={{
                     textAlign: 'center',
                     minWidth: column.minWidth,
                     backgroundColor: '#DAE7FF',
                     padding: 0,
                     color: '#000 !important',
                     fontWeight: '500',
                     fontFamily: "'Poppins', sans-serif",
                     fontSize: '13px',
                     padding: '10px 2px'
                   }}
                 >
                   {column.label}
                 </TableCell>
               ))}
             </TableRow>
           </TableHead>
           <TableBody>
             {Record1
               .slice(startIndex, endIndex)
               .map((row, index) => {

                 return (
                   <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                     {columns1.map((column) => {
                       const value = row[column.id];
                       return (
                         <TableCell
                           style={{
                             position: 'sticky',
                             backgroundColor: '#fff',
                             fontWeight: '500',
                             fontFamily: "'Poppins', sans-serif",
                             fontSize: '13px',
                             padding: '5px 2px'
                           }}
                           class="table-cell-screenerTab"
                           key={column.id}
                           align={column.align}
                         >
                           {column.id === "S.No"
                             ? <div>{index + 1}  <span onClick={()=>{ handleRemoveformArray(row,1) }}><CancelIcon  sx={{ width: 20, height: 20 ,color:'#23499E'}} /></span>  </div>
                             : column.id === 'Margin'
                               ? <div style={{ textAlign: 'right' }}>
                                 {value}
                                 <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => updateMargin(row)}>
                                   <Tooltip title={value === '' ? "Enter margin" : "Edit margin"} placement="right">
                                     {value === '' ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                   </Tooltip>
                                 </span>
                               </div> : column.id === 'lot'
                                 ? <div style={{ textAlign: 'right' }}>
                                   {value}
                                   <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => updateLotsize(row)}>
                                     <Tooltip title={value === '' ? "Enter Lot " : "Edit Lot "} placement="right">
                                       {value === '' ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                     </Tooltip>
                                   </span>
                                 </div> : value
                           }
                         </TableCell>
                       );
                     })}
                   </TableRow>
                 );
               })}
           </TableBody>
         </Table>
       </TableContainer>
       <TablePagination
         rowsPerPageOptions={[25, 50, 75, 100]}
         component="div"
         count={Record.length}
         rowsPerPage={rowsPerPage}
         page={page}
         onPageChange={handleChangePage}
         onRowsPerPageChange={handleChangeRowsPerPage}
       />
       </Paper>

       :selectedTab === "Option" ? 
       <Paper sx={{ width: '100%', overflow: 'hidden' }}>
       <TableContainer sx={{ maxHeight: 500 }}>
         <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
           <TableHead >
             <TableRow>
               {columns1.map((column, index) => (
                 <TableCell
                   key={column.id}
                   align={column.align}
                   style={{
                     textAlign: 'center',
                     minWidth: column.minWidth,
                     backgroundColor: '#DAE7FF',
                     padding: 0,
                     color: '#000 !important',
                     fontWeight: '500',
                     fontFamily: "'Poppins', sans-serif",
                     fontSize: '13px',
                     padding: '10px 2px'
                   }}
                 >
                   {column.label}
                 </TableCell>
               ))}
             </TableRow>
           </TableHead>
           <TableBody>
             {Record1
               .slice(startIndex, endIndex)
               .map((row, index) => {

                 return (
                   <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                     {columns1.map((column) => {
                       const value = row[column.id];
                       return (
                         <TableCell
                           style={{
                             position: 'sticky',
                             backgroundColor: '#fff',
                             fontWeight: '500',
                             fontFamily: "'Poppins', sans-serif",
                             fontSize: '13px',
                             padding: '5px 2px'
                           }}
                           class="table-cell-screenerTab"
                           key={column.id}
                           align={column.align}
                         >
                           {column.id === "S.No"
                             ? <div>{index + 1}  <span onClick={()=>{ handleRemoveformArray(row,1) }}><CancelIcon  sx={{ width: 20, height: 20 ,color:'#23499E'}} /></span>  </div>
                             : column.id === 'Margin'
                               ? <div style={{ textAlign: 'right' }}>
                                 {value}
                                 <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => updateMargin(row)}>
                                   <Tooltip title={value === '' ? "Enter margin" : "Edit margin"} placement="right">
                                     {value === '' ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                   </Tooltip>
                                 </span>
                               </div> : column.id === 'lot'
                                 ? <div style={{ textAlign: 'right' }}>
                                   {value}
                                   <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => updateLotsize(row)}>
                                     <Tooltip title={value === '' ? "Enter Lot " : "Edit Lot "} placement="right">
                                       {value === '' ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                     </Tooltip>
                                   </span>
                                 </div> : value
                           }
                         </TableCell>
                       );
                     })}
                   </TableRow>
                 );
               })}
           </TableBody>
         </Table>
       </TableContainer>
       <TablePagination
         rowsPerPageOptions={[25, 50, 75, 100]}
         component="div"
         count={Record.length}
         rowsPerPage={rowsPerPage}
         page={page}
         onPageChange={handleChangePage}
         onRowsPerPageChange={handleChangeRowsPerPage}
       />
       </Paper>
       :null}

      <Dialog
        open={marginUpdateModal}
        onClose={() => setmarginUpdateModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {SelectedRow.Margin == '' ? "Enter Margin" : "Update Margin"}
        </DialogTitle>
        <DialogContent style={{ width: '350px' }}>
          <div className="Authmain">
            <div className="Authcontent">
              {ErrorShow ?
                <span style={{ color: "red" }}>
                  {ErrorMessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Margin:<span className='asterisk'>*</span></p>
                <input value={newmargin} type="number" id="sl" name="sl" required onChange={handlemarginchange}
                // (e)=>setnewmargin(e.target.value)} 
                />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={() => setmarginUpdateModal(false)}>cancel</Button>
          <Button className='btn-yes' onClick={HandleMarginUpdate} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={LotSizeUpdateModal}
        onClose={() => setLotSizeUpdateModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {SelectedRow.lot_size == '' ? "Enter Lot size" : "Update Lot Size"}
        </DialogTitle>
        <DialogContent style={{ width: '350px' }}>
          <div className="Authmain">
            <div className="Authcontent">
              {ErrorShow ?
                <span style={{ color: "red" }}>
                  {AlertMessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Lot Size:<span className='asterisk'>*</span></p>
                <input value={NewLotSize} type="number" id="sl" name="sl" required onChange={handleLostSizechange}
                // (e)=>setnewmargin(e.target.value)} 
                />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={() => setLotSizeUpdateModal(false)}>cancel</Button>
          <Button className='btn-yes' onClick={HandleLotSizeUpdate} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Loading}
        onClose={() => { setLoading(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: 'transparent', // Set the background color to transparent
            boxShadow: 'none', // Optional: remove the shadow if desired
            overflow: 'hidden', // To ensure the dialog's paper doesn't exceed its custom content
          },
        }}
      >
        <div style={{ padding: '50px' }}>
          <ProgressBar
            visible={true}
            height="80"
            width="80"
            color="#23499E"
            barColor="#23499E"
            borderColor="#000000"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </Dialog>

      <Dialog
        open={showAlert}
        onClose={() => { setshowAlert(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
      </Dialog>

      <Dialog
        open={AlertModal}
        onClose={() => setAlertModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
          {"Confirmation "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to edit Lot No.?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={() => setAlertModal(false)}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={handleshowEditmodal}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>


      
      <Dialog
        open={AlertModalMargin}
        onClose={() => setAlertModalMargin(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
          {"Confirmation "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to Add/Edit margin?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={() => setAlertModalMargin(false)}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={handleshowEditMarginmodal}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  )
}

export default PerformanceTable